webpackJsonp([1],{

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(204)
}
var Component = __webpack_require__(146)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(211),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_datepicker_es6__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_datepicker_es6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__vue_datepicker_es6__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jQuery__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jQuery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jQuery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);









function isIE9OrBelow() {
  return (/MSIE\s/.test(navigator.userAgent) && parseFloat(navigator.appVersion.split("MSIE")[1]) < 10
  );
}

__WEBPACK_IMPORTED_MODULE_3_jQuery___default.a.fn.extend({
  animateCss: function animateCss(animationName, callback) {
    if (isIE9OrBelow()) {
      if (callback && callback == 'hide') __WEBPACK_IMPORTED_MODULE_3_jQuery___default()(this).hide();else if (callback) callback();
    }
    __WEBPACK_IMPORTED_MODULE_3_jQuery___default()(this).removeClass('animated ' + animationName);
    var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
    __WEBPACK_IMPORTED_MODULE_3_jQuery___default()(this).unbind(animationEnd);
    __WEBPACK_IMPORTED_MODULE_3_jQuery___default()(this).addClass('animated ' + animationName).one(animationEnd, function () {
      __WEBPACK_IMPORTED_MODULE_3_jQuery___default()(this).removeClass('animated ' + animationName);
      if (callback && callback == 'hide') __WEBPACK_IMPORTED_MODULE_3_jQuery___default()(this).hide();else if (callback) callback();
    });
    return this;
  }
});

var form_dom = __WEBPACK_IMPORTED_MODULE_3_jQuery___default()('#single_page_valuation');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      select_options: [],

      select_country: '',

      pdf_string: '',

      dropzone_translation: {
        dictRemoveFile: lang['upload_remove'],
        dictDefaultMessage: lang['upload_message'],
        dictCancelUpload: lang['upload_cancel'],
        dictFileTooBig: lang['upload_too_big'],
        dictMaxFilesExceeded: lang['upload_too_many']
      },

      endpoint_url: root_url + 'endpoint.php',

      lang: lang,
      current_screen: 'car',

      car_brand: '',
      car_number: '',
      car_model: '',
      car_weight: '',

      client_date: '',
      client_city: '',
      client_name: '',
      client_country: '',
      client_street: '',
      client_street_number: '',
      client_postal_code: '',
      client_document_number: '',
      client_document_issued: '',
      client_phone: '',
      client_email: '',

      date: {
        time: '' },

      datepicker_options: {
        type: 'day',
        week: ['Pon', 'Wt', 'Śr', 'Czw', 'Piąt', 'Sob', 'Ndz'],
        month: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
        format: 'YYYY-MM-DD',
        placeholder: '',

        buttons: {
          ok: 'Ok',
          cancel: 'Anuluj'
        }
      }

    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_jQuery___default()('#single_page_valuation').addClass('loaded');

    this.$persist(['car_brand', 'car_number', 'car_model', 'car_weight', 'client_date', 'client_city', 'client_name', 'client_name', 'client_country', 'client_street', 'client_street_number', 'client_postal_code', 'client_document_number', 'client_document_issued', 'client_phone', 'client_email', 'select_country']);

    this.date.time = this.client_date;

    function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    var selected_country_code = getCookie('country_code');
    var selected_country = country_codes[selected_country_code][0]['FIELD2'];

    if (this.client_country == '') {

      this.client_country = selected_country_code;

      this.select_country = {
        value: selected_country_code,
        label: selected_country
      };
    }

    var sorted_codes = [];

    __WEBPACK_IMPORTED_MODULE_3_jQuery___default.a.each(country_codes, function (index, val) {
      var insert = {};

      insert['value'] = index;
      insert['label'] = val[0]['FIELD2'];

      sorted_codes.push(insert);
    });

    this.select_options = sorted_codes;

    var parameters = {
      action: 'list_files'
    };

    var query_string = __WEBPACK_IMPORTED_MODULE_3_jQuery___default.a.param(parameters);

    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.endpoint_url, query_string).then(function (response) {

      var files = response.data.files;
      var folder = response.data.folder;

      var instance = _this;

      files.forEach(function (val, index) {
        var mockFile = { name: val['name'], size: val['size'] };
        var path = root_url + '/email_uploads/' + folder + '/' + val['name'];
        instance.$refs.dropzone_ref.manuallyAddFile(mockFile, path);
      });
    }).catch(function (e) {
      console.log(e);
    });
  },


  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_0__vue_datepicker_es6___default.a,
    'Dropzone': __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default.a,
    'multiselect': __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a
  },

  watch: {

    'date.time': function dateTime() {
      this.client_date = this.date.time;
    },
    'select_country': function select_country() {
      this.client_country = this.select_country.value;
    }

  },

  methods: {

    'set_code': function set_code(payload) {
      if (payload['value']) {
        this.client_country = payload['value'];

        this.select_country = payload['label'];
      }
    },

    'to_first_screen': function to_first_screen() {

      this.current_screen = 'car';
      __WEBPACK_IMPORTED_MODULE_3_jQuery___default()('html, body').animate({ scrollTop: 0 }, 200);
    },
    'to_second_screen': function to_second_screen() {
      this.$validator.validateAll({
        car_brand: this.car_brand,
        car_model: this.car_model,
        car_number: this.car_number,
        car_weight: this.car_weight
      });

      if (!this.errors.has('car_brand') && !this.errors.has('car_model') && !this.errors.has('car_number') && !this.errors.has('car_weight')) {

        this.current_screen = 'client';
        __WEBPACK_IMPORTED_MODULE_3_jQuery___default()('html, body').animate({ scrollTop: 0 }, 200);
      } else {
        __WEBPACK_IMPORTED_MODULE_3_jQuery___default()('#single_page__next').animateCss('shake');
      }
    },

    'uploaded_file': function uploaded_file(file, response) {
      response = JSON.parse(response);
      file.previewElement.setAttribute('server_name', response.name);
    },

    'remove_file': function remove_file(file, error, xhr) {

      var filename = file.name;

      if (file.previewElement.hasAttribute('server_name')) {
        filename = file.previewElement.getAttribute('server_name');
      }

      var parameters = {
        action: 'remove_file',
        name: filename
      };

      var query_string = __WEBPACK_IMPORTED_MODULE_3_jQuery___default.a.param(parameters);

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.endpoint_url, query_string).then(function (response) {}).catch(function (e) {
        console.log('nie mozna usunac z serwera');
      });
    },

    'sending_file': function sending_file(file, xhr, formData) {
      formData.append('action', 'upload_file');
    },

    'send_email': function send_email() {
      var _this2 = this;

      var email_data = {
        car_brand: this.car_brand,
        car_model: this.car_model,
        car_number: this.car_number,
        car_weight: this.car_weight,
        client_city: this.client_city,
        client_country: this.client_country,
        client_date: this.client_date,
        client_document_issued: this.client_document_issued,
        client_document_number: this.client_document_number,
        client_email: this.client_email,
        client_name: this.client_name,
        client_phone: this.client_phone,
        client_postal_code: this.client_postal_code,
        client_street: this.client_street,
        client_street_number: this.client_street_number
      };

      var parameters = {
        action: 'send_cat',
        object: this.client_to_base,
        object_cat_email: email_data,
        pdf_string: this.pdf_string
      };

      var query_string = __WEBPACK_IMPORTED_MODULE_3_jQuery___default.a.param(parameters);

      this.$validator.validateAll();

      if (!this.errors.any()) {

        form_dom.addClass('sending');

        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.endpoint_url, query_string).then(function (response) {

          form_dom.removeClass('sending');

          if (response['data']['send_email_status'] == 'ok') {
            pnotify(lang['send_ok']);

            _this2.reset_form();
          } else {
            pnotify(lang['send_backend_error']);
          }
        }).catch(function (e) {
          pnotify(lang['send_connection_error'], 'error');
          console.log(e);
          form_dom.removeClass('sending');
        });
      } else {
        pnotify(lang['send_validation_error'], 'error');
      }
    },

    'reset_form': function reset_form() {
      this.car_brand = '';
      this.car_model = '';
      this.car_number = '';
      this.car_weight = '';

      this.client_city = '';
      this.client_country = '';
      this.client_document_issued = '';
      this.client_document_number = '';
      this.client_email = '';
      this.client_name = '';
      this.client_phone = '';
      this.client_postal_code = '';
      this.client_street = '';
      this.client_street_number = '';
      this.client_city = '';
      this.client_date = '';
      this.date.time = '';

      this.$refs.dropzone_ref.removeAllFiles();

      __WEBPACK_IMPORTED_MODULE_3_jQuery___default()('.dz-preview').remove();

      this.errors.clear();

      this.current_screen = 'car';
    },

    'generate_pdf': function generate_pdf(type) {

      this.$validator.validateAll();

      if (!this.errors.any()) {
        form_dom.addClass('sending');

        var date = new Date();
        var now_date = date.getDate() + '-' + date.getMonth() + '-' + date.getFullYear();

        var form_date = this.client_date;

        var form_city = this.client_city;
        var form_name = this.client_name;
        var form_street = this.client_street;
        var form_street_number = this.client_street_number;
        var form_postal_code = this.client_postal_code;

        var form_marka = this.car_brand;
        var form_number = this.car_number;
        var form_model = this.car_model;
        var form_weight = this.car_weight;
        var form_country = this.client_country;
        var form_passport_number = this.client_document_number;
        var form_gifted = this.client_document_issued;
        var form_phone = this.client_phone;
        var form_email = this.client_email;

        var line_height = 1.2;

        var docDefinition = {
          pageSize: 'A4',
          background: { image: image_logo, width: 540, margin: [30, 300, 30, 300] },
          content: [{ image: image_bg, width: 250 }, { text: 'UMOWA KUPNA SPRZEDAŻY', style: 'header', margin: [0, 50, 0, 30] }, { text: 'W dniu ' + now_date + ' w Mińsku Mazowieckim pomiędzy: ', margin: [0, 0, 0, 20], lineHeight: line_height }, { text: form_name + ', zamieszkały ul.' + form_street + ' ' + form_street_number + ', ' + form_postal_code + ' ' + form_city + ', ' + form_country + ', legitymujący się dowodem osobistym nr ' + form_passport_number + ', wydanym przez: ' + form_gifted + ' zwanym dalej sprzedawcą, ', margin: [0, 0, 0, 20], lineHeight: line_height }, { text: 'a Valdi Katalizatory - Skup katalizatorów, ul. Średnia 5, 05-555 Tarczyn, NIP: 7971504304 zwanym dalej kupującym została sporządzona niniejsza umowa. ', margin: [0, 0, 0, 20], lineHeight: line_height }, { text: '1. Sprzedawca zobowiązuje się, że do dnia ' + form_date + ' dostarczy kupującemu następujący towar: katalizator o nr ' + form_model + ' pochodzący z auta ' + form_marka + '.', lineHeight: line_height }, { text: '2. Wynagrodzenie za towar strony ustaliły w wysokości ………………………… PLN.', lineHeight: line_height }, { text: '3. Kupujący zobowiązuje się do odbioru dostarczonego towaru i zapłaty ceny.', lineHeight: line_height }, { text: '4. Strony ustalają, że towar nie zostanie odebrany do czasu, gdy Kupujący dokona jego oględzin i stwierdzi, że jest on zgodny z zamówieniem.', lineHeight: line_height }, { text: '5. Kupujący stwierdza, że cenę za dostarczony towar uiści w miejscu odbioru.', lineHeight: line_height }, { text: '6. Towar uważa się za odebrany z chwilą jego dostarczenia na adres Kupującego, wymieniony w niniejszej umowie.', lineHeight: line_height }, { text: '7. Do czasu odbioru towaru przez Kupującego ryzyko związane z utratą lub uszkodzeniem towaru ponosi Sprzedawca.', lineHeight: line_height }, { text: '8. Sprzedawca oświadcza, że nie istnieją ani nie są wysuwane jakiekolwiek roszczenia osób trzecich podważające wiarygodność niniejszej umowy. Sprzedawca oświadcza, że towar wolny jest od wszelkich wad prawnych i fizycznych.', lineHeight: line_height }, { text: '9. Kupujący posiada prawo do zbadania dostarczonego towaru i poinformowania Sprzedawcy w terminie 10 dni roboczych o jakichkolwiek stwierdzonych wadach, ubytkach lub uszkodzeniach. W przypadku ich nie zgłoszenia, uważa się że towar został odebrany bez zastrzeżeń', lineHeight: line_height }, { text: '10. Sprzedający podpisując umowę deklaruje, iż sprzedawany towar nie pochodzi z działalności przestępczej (np. kradzież, paserstwo).', lineHeight: line_height }, { text: '11. niniejszym umowa została sporządzona w dwóch jednobrzmiących egzemplarzach po jednym dla każdej ze stron. ', lineHeight: line_height }, {
            columns: [{
              width: '50%',
              text: 'Podpis Sprzedającego',
              style: 'column_left',
              margin: [0, 30, 0, 0]
            }, {
              width: '50%',
              text: 'Podpis Kupującego',
              style: 'column_right',
              margin: [0, 30, 0, 0]
            }],
            columnGap: 0
          }],
          styles: {
            header: {
              fontSize: 20,
              bold: true,
              alignment: 'center'
            },
            column_left: {
              alignment: 'left'
            },
            column_right: {
              alignment: 'right'
            }
          }
        };

        var instance = this;

        var date = new Date();
        date = date.getSeconds() + '-' + date.getDate() + '-' + date.getMonth() + '-' + date.getFullYear();
        pdfMake.createPdf(docDefinition).download('umowa-' + form_marka + '-' + date);

        pdfMake.createPdf(docDefinition).getDataUrl(function (data) {

          instance.pdf_string = data;
          instance.send_email();
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_3_jQuery___default()('#single_page__send').animateCss('shake');
      }
    }

  },

  computed: {

    client_to_base: function client_to_base() {
      var object = {
        name: this.client_name,
        email: this.client_email,
        phone: this.client_phone,
        city: this.client_city,
        postalCode: this.client_postal_code,
        street: this.client_street,
        streetNumber: this.client_street_number,
        country: this.client_country,
        type: 'cat-form' };

      return object;
    }

  }

});

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    required: false,
    date: {
      type: Object,
      required: true
    },
    option: {
      type: Object,
      default: function _default() {
        return {
          type: 'day',
          SundayFirst: false,
          week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
          month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          format: 'YYYY-MM-DD',
          color: {
            checked: '#F50057',
            header: '#3f51b5',
            headerText: '#fff'
          },
          inputStyle: {
            'display': 'inline-block',
            'padding': '6px',
            'line-height': '22px',
            'font-size': '16px',
            'border': '2px solid #fff',
            'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
            'border-radius': '2px',
            'color': '#5F5F5F'
          },
          placeholder: 'when?',
          buttons: {
            ok: 'OK',
            cancel: 'Cancel'
          },
          overlayOpacity: 0.5,
          dismissible: true
        };
      }
    },
    limit: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    function hours() {
      var list = [];
      var hour = 24;
      while (hour > 0) {
        hour--;
        list.push({
          checked: false,
          value: hour < 10 ? '0' + hour : hour
        });
      }
      return list;
    }
    function mins() {
      var list = [];
      var min = 60;
      while (min > 0) {
        min--;
        list.push({
          checked: false,
          value: min < 10 ? '0' + min : min
        });
      }
      return list;
    }
    return {
      hours: hours(),
      mins: mins(),
      showInfo: {
        hour: false,
        day: false,
        month: false,
        year: false,
        check: false
      },
      displayInfo: {
        month: ''
      },
      library: {
        week: this.option.week,
        month: this.option.month,
        year: []
      },
      checked: {
        oldtime: '',
        currentMoment: null,
        year: '',
        month: '',
        day: '',
        hour: '00',
        min: '00'
      },
      dayList: [],
      selectedDays: []
    };
  },


  computed: {
    computedDate: function computedDate() {
      return this.checked.currentMoment;
    }
  },

  created: function created() {

    if (this.date.time != '') {
      this.checked.currentMoment = this.date.time;
    }
  },

  methods: {
    pad: function pad(n) {
      n = Math.floor(n);
      return n < 10 ? '0' + n : n;
    },
    nextMonth: function nextMonth(type) {
      var next = null;
      type === 'next' ? next = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).add(1, 'M') : next = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).add(-1, 'M');
      this.showDay(next);
    },
    showDay: function showDay(time) {
      if (time === undefined || !Date.parse(time)) {
        this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      } else {
        this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(time, this.option.format);
      }
      this.showOne('day');
      this.checked.year = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format('YYYY');
      this.checked.month = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format('MM');
      this.checked.day = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format('DD');
      this.displayInfo.month = this.library.month[__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).month()];
      var days = [];
      var currentMoment = this.checked.currentMoment;
      var firstDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).date(1).day();

      var previousMonth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment);
      var nextMonth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment);
      nextMonth.add(1, 'months');
      previousMonth.subtract(1, 'months');
      var monthDays = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).daysInMonth();
      var oldtime = this.checked.oldtime;
      for (var i = 1; i <= monthDays; ++i) {
        days.push({
          value: i,
          inMonth: true,
          unavailable: false,
          checked: false,
          moment: __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).date(i)
        });
        if (i === Math.ceil(__WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).format('D')) && __WEBPACK_IMPORTED_MODULE_2_moment___default()(oldtime, this.option.format).year() === __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).year() && __WEBPACK_IMPORTED_MODULE_2_moment___default()(oldtime, this.option.format).month() === __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).month()) {
          days[i - 1].checked = true;
        }
        this.checkBySelectDays(i, days);
      }
      if (firstDay === 0) firstDay = 7;
      for (var _i = 0; _i < firstDay - (this.option.SundayFirst ? 0 : 1); _i++) {
        var passiveDay = {
          value: previousMonth.daysInMonth() - _i,
          inMonth: false,
          action: 'previous',
          unavailable: false,
          checked: false,
          moment: __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).date(1).subtract(_i + 1, 'days')
        };
        days.unshift(passiveDay);
      }
      if (this.limit.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.limit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var li = _step.value;

            switch (li.type) {
              case 'fromto':
                days = this.limitFromTo(li, days);
                break;
              case 'weekday':
                days = this.limitWeekDay(li, days);
                break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      var passiveDaysAtFinal = 42 - days.length;
      for (var _i2 = 1; _i2 <= passiveDaysAtFinal; _i2++) {
        var _passiveDay = {
          value: _i2,
          inMonth: false,
          action: 'next',
          unavailable: false,
          checked: false,
          moment: __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).add(1, 'months').date(_i2)
        };
        days.push(_passiveDay);
      }
      this.dayList = days;
    },
    checkBySelectDays: function checkBySelectDays(d, days) {
      var _this = this;

      this.selectedDays.forEach(function (day) {
        if (_this.checked.year === __WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('YYYY') && _this.checked.month === __WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('MM') && d === Math.ceil(__WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('D'))) {
          days[d - 1].checked = true;
        }
      });
    },
    limitWeekDay: function limitWeekDay(limit, days) {
      days.map(function (day) {
        if (limit.available.indexOf(Math.floor(day.moment.format('d'))) === -1) {
          day.unavailable = true;
        }
      });
      return days;
    },
    limitFromTo: function limitFromTo(limit, days) {
      var _this2 = this;

      if (limit.from || limit.to) {
        days.map(function (day) {
          if (_this2.getLimitCondition(limit, day)) {
            day.unavailable = true;
          }
        });
      }
      return days;
    },
    getLimitCondition: function getLimitCondition(limit, day) {
      var tmpMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.year + '-' + this.pad(this.checked.month) + '-' + this.pad(day.value));
      if (limit.from && !limit.to) {
        return !tmpMoment.isAfter(limit.from);
      } else if (!limit.from && limit.to) {
        return !tmpMoment.isBefore(limit.to);
      } else {
        return !tmpMoment.isBetween(limit.from, limit.to);
      }
    },
    checkDay: function checkDay(obj) {
      if (obj.unavailable || obj.value === '') {
        return false;
      }
      if (!obj.inMonth) {
        this.nextMonth(obj.action);
      }
      if (this.option.type === 'day' || this.option.type === 'min') {
        this.dayList.forEach(function (x) {
          x.checked = false;
        });
        this.checked.day = this.pad(obj.value);
        obj.checked = true;
      } else {
        var day = this.pad(obj.value);
        var ctime = this.checked.year + '-' + this.checked.month + '-' + day;
        if (obj.checked === true) {
          obj.checked = false;
          this.selectedDays.$remove(ctime);
        } else {
          this.selectedDays.push(ctime);
          obj.checked = true;
        }
      }
      switch (this.option.type) {
        case 'day':
          this.picked();
          break;
        case 'min':
          this.showOne('hour');

          this.shiftActTime();
          break;
      }
    },
    showYear: function showYear() {
      var _this3 = this;

      var year = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).year();
      this.library.year = [];
      var yearTmp = [];
      for (var i = year - 100; i < year + 5; ++i) {
        yearTmp.push(i);
      }
      this.library.year = yearTmp;
      this.showOne('year');
      this.$nextTick(function () {
        var listDom = document.getElementById('yearList');
        listDom.scrollTop = listDom.scrollHeight - 100;
        _this3.addYear();
      });
    },
    showOne: function showOne(type) {
      switch (type) {
        case 'year':
          this.showInfo.hour = false;
          this.showInfo.day = false;
          this.showInfo.year = true;
          this.showInfo.month = false;
          break;
        case 'month':
          this.showInfo.hour = false;
          this.showInfo.day = false;
          this.showInfo.year = false;
          this.showInfo.month = true;
          break;
        case 'day':
          this.showInfo.hour = false;
          this.showInfo.day = true;
          this.showInfo.year = false;
          this.showInfo.month = false;
          break;
        case 'hour':
          this.showInfo.hour = true;
          this.showInfo.day = false;
          this.showInfo.year = false;
          this.showInfo.month = false;
          break;
        default:
          this.showInfo.day = true;
          this.showInfo.year = false;
          this.showInfo.month = false;
          this.showInfo.hour = false;
      }
    },
    showMonth: function showMonth() {
      this.showOne('month');
    },
    addYear: function addYear() {
      var _this4 = this;

      var listDom = document.getElementById('yearList');
      listDom.addEventListener('scroll', function (e) {
        if (listDom.scrollTop < listDom.scrollHeight - 100) {
          var len = _this4.library.year.length;
          var lastYear = _this4.library.year[len - 1];
          _this4.library.year.push(lastYear + 1);
        }
      }, false);
    },
    setYear: function setYear(year) {
      this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(year + '-' + this.checked.month + '-' + this.checked.day);
      this.showDay(this.checked.currentMoment);
    },
    setMonth: function setMonth(month) {
      var mo = this.library.month.indexOf(month) + 1;
      if (mo < 10) {
        mo = '0' + '' + mo;
      }
      this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.year + '-' + mo + '-' + this.checked.day);
      this.showDay(this.checked.currentMoment);
    },
    showCheck: function showCheck() {
      if (this.date.time === '') {
        this.showDay();
      } else {
        if (this.option.type === 'day' || this.option.type === 'min') {
          this.checked.oldtime = this.date.time;
          this.showDay(this.date.time);
        } else {
          this.selectedDays = JSON.parse(this.date.time);
          if (this.selectedDays.length) {
            this.checked.oldtime = this.selectedDays[0];
            this.showDay(this.selectedDays[0]);
          } else {
            this.showDay();
          }
        }
      }
      this.showInfo.check = true;
    },
    setTime: function setTime(type, obj, list) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          item.checked = false;
          if (item.value === obj.value) {
            item.checked = true;
            this.checked[type] = item.value;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    picked: function picked() {
      if (this.option.type === 'day' || this.option.type === 'min') {
        var ctime = this.checked.year + '-' + this.checked.month + '-' + this.checked.day + ' ' + this.checked.hour + ':' + this.checked.min;
        this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(ctime, 'YYYY-MM-DD HH:mm');
        this.date.time = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format(this.option.format);
      } else {
        this.date.time = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedDays);
      }
      this.showInfo.check = false;
      this.$emit('change', this.date.time);
      this.$emit('input', this.date.time);
      this.$emit('blur', this.date.time);
    },
    dismiss: function dismiss(evt) {
      if (evt.target.className === 'datepicker-overlay') {
        if (this.option.dismissible === undefined || this.option.dismissible) {
          this.showInfo.check = false;
          this.$emit('cancel');
        }
      }
    },
    shiftActTime: function shiftActTime() {
      this.$nextTick(function () {
        if (!document.querySelector('.hour-item.active')) {
          return false;
        }
        document.querySelector('.hour-box').scrollTop = (document.querySelector('.hour-item.active').offsetTop || 0) - 250;
        document.querySelector('.min-box').scrollTop = (document.querySelector('.min-item.active').offsetTop || 0) - 250;
      });
    }
  }
});

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_persist__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_persist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_persist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vee_validate__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_persist___default.a);

var validate_config = {
  locale: 'pl',
  events: 'blur'
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vee_validate___default.a, validate_config);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.devtools = true;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__form___default.a }
});

/***/ }),

/***/ 204:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 205:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 31,
	"./af.js": 31,
	"./ar": 38,
	"./ar-dz": 32,
	"./ar-dz.js": 32,
	"./ar-kw": 33,
	"./ar-kw.js": 33,
	"./ar-ly": 34,
	"./ar-ly.js": 34,
	"./ar-ma": 35,
	"./ar-ma.js": 35,
	"./ar-sa": 36,
	"./ar-sa.js": 36,
	"./ar-tn": 37,
	"./ar-tn.js": 37,
	"./ar.js": 38,
	"./az": 39,
	"./az.js": 39,
	"./be": 40,
	"./be.js": 40,
	"./bg": 41,
	"./bg.js": 41,
	"./bn": 42,
	"./bn.js": 42,
	"./bo": 43,
	"./bo.js": 43,
	"./br": 44,
	"./br.js": 44,
	"./bs": 45,
	"./bs.js": 45,
	"./ca": 46,
	"./ca.js": 46,
	"./cs": 47,
	"./cs.js": 47,
	"./cv": 48,
	"./cv.js": 48,
	"./cy": 49,
	"./cy.js": 49,
	"./da": 50,
	"./da.js": 50,
	"./de": 53,
	"./de-at": 51,
	"./de-at.js": 51,
	"./de-ch": 52,
	"./de-ch.js": 52,
	"./de.js": 53,
	"./dv": 54,
	"./dv.js": 54,
	"./el": 55,
	"./el.js": 55,
	"./en-au": 56,
	"./en-au.js": 56,
	"./en-ca": 57,
	"./en-ca.js": 57,
	"./en-gb": 58,
	"./en-gb.js": 58,
	"./en-ie": 59,
	"./en-ie.js": 59,
	"./en-nz": 60,
	"./en-nz.js": 60,
	"./eo": 61,
	"./eo.js": 61,
	"./es": 63,
	"./es-do": 62,
	"./es-do.js": 62,
	"./es.js": 63,
	"./et": 64,
	"./et.js": 64,
	"./eu": 65,
	"./eu.js": 65,
	"./fa": 66,
	"./fa.js": 66,
	"./fi": 67,
	"./fi.js": 67,
	"./fo": 68,
	"./fo.js": 68,
	"./fr": 71,
	"./fr-ca": 69,
	"./fr-ca.js": 69,
	"./fr-ch": 70,
	"./fr-ch.js": 70,
	"./fr.js": 71,
	"./fy": 72,
	"./fy.js": 72,
	"./gd": 73,
	"./gd.js": 73,
	"./gl": 74,
	"./gl.js": 74,
	"./gom-latn": 75,
	"./gom-latn.js": 75,
	"./he": 76,
	"./he.js": 76,
	"./hi": 77,
	"./hi.js": 77,
	"./hr": 78,
	"./hr.js": 78,
	"./hu": 79,
	"./hu.js": 79,
	"./hy-am": 80,
	"./hy-am.js": 80,
	"./id": 81,
	"./id.js": 81,
	"./is": 82,
	"./is.js": 82,
	"./it": 83,
	"./it.js": 83,
	"./ja": 84,
	"./ja.js": 84,
	"./jv": 85,
	"./jv.js": 85,
	"./ka": 86,
	"./ka.js": 86,
	"./kk": 87,
	"./kk.js": 87,
	"./km": 88,
	"./km.js": 88,
	"./kn": 89,
	"./kn.js": 89,
	"./ko": 90,
	"./ko.js": 90,
	"./ky": 91,
	"./ky.js": 91,
	"./lb": 92,
	"./lb.js": 92,
	"./lo": 93,
	"./lo.js": 93,
	"./lt": 94,
	"./lt.js": 94,
	"./lv": 95,
	"./lv.js": 95,
	"./me": 96,
	"./me.js": 96,
	"./mi": 97,
	"./mi.js": 97,
	"./mk": 98,
	"./mk.js": 98,
	"./ml": 99,
	"./ml.js": 99,
	"./mr": 100,
	"./mr.js": 100,
	"./ms": 102,
	"./ms-my": 101,
	"./ms-my.js": 101,
	"./ms.js": 102,
	"./my": 103,
	"./my.js": 103,
	"./nb": 104,
	"./nb.js": 104,
	"./ne": 105,
	"./ne.js": 105,
	"./nl": 107,
	"./nl-be": 106,
	"./nl-be.js": 106,
	"./nl.js": 107,
	"./nn": 108,
	"./nn.js": 108,
	"./pa-in": 109,
	"./pa-in.js": 109,
	"./pl": 110,
	"./pl.js": 110,
	"./pt": 112,
	"./pt-br": 111,
	"./pt-br.js": 111,
	"./pt.js": 112,
	"./ro": 113,
	"./ro.js": 113,
	"./ru": 114,
	"./ru.js": 114,
	"./sd": 115,
	"./sd.js": 115,
	"./se": 116,
	"./se.js": 116,
	"./si": 117,
	"./si.js": 117,
	"./sk": 118,
	"./sk.js": 118,
	"./sl": 119,
	"./sl.js": 119,
	"./sq": 120,
	"./sq.js": 120,
	"./sr": 122,
	"./sr-cyrl": 121,
	"./sr-cyrl.js": 121,
	"./sr.js": 122,
	"./ss": 123,
	"./ss.js": 123,
	"./sv": 124,
	"./sv.js": 124,
	"./sw": 125,
	"./sw.js": 125,
	"./ta": 126,
	"./ta.js": 126,
	"./te": 127,
	"./te.js": 127,
	"./tet": 128,
	"./tet.js": 128,
	"./th": 129,
	"./th.js": 129,
	"./tl-ph": 130,
	"./tl-ph.js": 130,
	"./tlh": 131,
	"./tlh.js": 131,
	"./tr": 132,
	"./tr.js": 132,
	"./tzl": 133,
	"./tzl.js": 133,
	"./tzm": 135,
	"./tzm-latn": 134,
	"./tzm-latn.js": 134,
	"./tzm.js": 135,
	"./uk": 136,
	"./uk.js": 136,
	"./ur": 137,
	"./ur.js": 137,
	"./uz": 139,
	"./uz-latn": 138,
	"./uz-latn.js": 138,
	"./uz.js": 139,
	"./vi": 140,
	"./vi.js": 140,
	"./x-pseudo": 141,
	"./x-pseudo.js": 141,
	"./yo": 142,
	"./yo.js": 142,
	"./zh-cn": 143,
	"./zh-cn.js": 143,
	"./zh-hk": 144,
	"./zh-hk.js": 144,
	"./zh-tw": 145,
	"./zh-tw.js": 145
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 208;

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(205)
}
var Component = __webpack_require__(146)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(212),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6407f5e6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 211:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "cat_form"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.current_screen == 'car'),
      expression: "current_screen == 'car'"
    }],
    staticClass: "screen_cat"
  }, [_c('div', {
    staticClass: "single_page__form_item",
    class: {
      'invalid': _vm.errors.has('car_brand')
    },
    attrs: {
      "data-balloon": _vm.lang.valuation_form_required_error,
      "data-balloon-pos": "right"
    }
  }, [_c('label', {
    staticClass: "blue",
    attrs: {
      "for": "car_brand"
    }
  }, [_vm._v(_vm._s(_vm.lang.valuation_form_marka))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.car_brand),
      expression: "car_brand"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "car_brand",
      "id": "car_brand"
    },
    domProps: {
      "value": (_vm.car_brand)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.car_brand = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "single_page__form_item",
    class: {
      'invalid': _vm.errors.has('car_number')
    },
    attrs: {
      "data-balloon": _vm.lang.valuation_form_required_error,
      "data-balloon-pos": "right"
    }
  }, [_c('label', {
    staticClass: "blue",
    attrs: {
      "for": "car_number"
    }
  }, [_vm._v(_vm._s(_vm.lang.valuation_form_number))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.car_number),
      expression: "car_number"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "car_number",
      "id": "car_number"
    },
    domProps: {
      "value": (_vm.car_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.car_number = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "single_page__form_item",
    class: {
      'invalid': _vm.errors.has('car_model')
    },
    attrs: {
      "data-balloon": _vm.lang.valuation_form_required_error,
      "data-balloon-pos": "right"
    }
  }, [_c('label', {
    staticClass: "blue",
    attrs: {
      "for": "car_model"
    }
  }, [_vm._v(_vm._s(_vm.lang.valuation_form_model))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.car_model),
      expression: "car_model"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "car_model",
      "id": "car_model"
    },
    domProps: {
      "value": (_vm.car_model)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.car_model = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "single_page__form_item",
    class: {
      'invalid': _vm.errors.has('car_weight')
    },
    attrs: {
      "data-balloon": _vm.lang.valuation_form_required_error,
      "data-balloon-pos": "right"
    }
  }, [_c('label', {
    staticClass: "blue",
    attrs: {
      "for": "car_weight"
    }
  }, [_vm._v(_vm._s(_vm.lang.valuation_form_weight))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.car_weight),
      expression: "car_weight"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "car_weight",
      "id": "car_weight"
    },
    domProps: {
      "value": (_vm.car_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.car_weight = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('dropzone', {
    ref: "dropzone_ref",
    attrs: {
      "id": "myVueDropzone",
      "url": _vm.endpoint_url,
      "accepted-file-types": "image/*",
      "max-file-size-in-m-b": 10,
      "max-number-of-files": 10,
      "language": _vm.dropzone_translation
    },
    on: {
      "vdropzone-success": _vm.uploaded_file,
      "vdropzone-removed-file": _vm.remove_file,
      "vdropzone-sending": _vm.sending_file
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "single_page__form_buttons"
  }, [_c('button', {
    staticClass: "single_page__button",
    attrs: {
      "id": "single_page__next"
    },
    on: {
      "click": _vm.to_second_screen
    }
  }, [_vm._v(_vm._s(_vm.lang.valuation_next))])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.current_screen == 'client'),
      expression: "current_screen == 'client'"
    }],
    staticClass: "screen_client"
  }, [_c('div', {
    staticClass: "single_page__form_item",
    class: {
      'invalid': _vm.errors.has('client_date')
    },
    attrs: {
      "data-balloon": _vm.lang.valuation_form_required_error,
      "data-balloon-pos": "right"
    }
  }, [_c('label', {
    staticClass: "silver",
    attrs: {
      "for": "form_date"
    }
  }, [_vm._v(_vm._s(_vm.lang.valuation_form_date))]), _vm._v(" "), _c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "date": _vm.date,
      "option": _vm.datepicker_options,
      "data-vv-name": "client_date",
      "data-vv-value-path": "computedDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "single_page__form_item",
    class: {
      'invalid': _vm.errors.has('client_city')
    },
    attrs: {
      "data-balloon": _vm.lang.valuation_form_required_error,
      "data-balloon-pos": "right"
    }
  }, [_c('label', {
    staticClass: "silver",
    attrs: {
      "for": "client_city"
    }
  }, [_vm._v(_vm._s(_vm.lang.valuation_form_city))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_city),
      expression: "client_city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "client_city",
      "id": "client_city"
    },
    domProps: {
      "value": (_vm.client_city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client_city = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "single_page__form_item",
    class: {
      'invalid': _vm.errors.has('client_name')
    },
    attrs: {
      "data-balloon": _vm.lang.valuation_form_required_error,
      "data-balloon-pos": "right"
    }
  }, [_c('label', {
    staticClass: "silver",
    attrs: {
      "for": "client_name"
    }
  }, [_vm._v(_vm._s(_vm.lang.valuation_form_name))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_name),
      expression: "client_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "client_name",
      "id": "client_name"
    },
    domProps: {
      "value": (_vm.client_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "single_page__form_item",
    class: {
      'invalid': _vm.errors.has('client_country')
    },
    attrs: {
      "data-balloon": _vm.lang.valuation_form_required_error,
      "data-balloon-pos": "right"
    }
  }, [_c('label', {
    staticClass: "silver",
    attrs: {
      "for": "form_country"
    }
  }, [_vm._v(_vm._s(_vm.lang.valuation_form_country))]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.select_options,
      "close-on-select": true,
      "show-labels": true,
      "placeholder": "Wybierz kraj",
      "label": "label",
      "track-by": "label",
      "selectLabel": _vm.lang.cat_form_select_label,
      "deselectLabel": "",
      "allowEmpty": false,
      "selectedLabel": _vm.lang.cat_form_country_selected
    },
    model: {
      value: (_vm.select_country),
      callback: function($$v) {
        _vm.select_country = $$v
      },
      expression: "select_country"
    }
  }), _vm._v(" "), _c('pre', {
    staticClass: "language-json"
  }, [_c('code', [_vm._v(_vm._s(_vm.country_code))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "single_page__form_item",
    class: {
      'invalid': _vm.errors.has('client_street')
    },
    attrs: {
      "data-balloon": _vm.lang.valuation_form_required_error,
      "data-balloon-pos": "right"
    }
  }, [_c('label', {
    staticClass: "silver",
    attrs: {
      "for": "client_street"
    }
  }, [_vm._v(_vm._s(_vm.lang.valuation_form_street))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_street),
      expression: "client_street"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "client_street",
      "id": "client_street"
    },
    domProps: {
      "value": (_vm.client_street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client_street = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "single_page__form_item",
    class: {
      'invalid': _vm.errors.has('client_street_number')
    },
    attrs: {
      "data-balloon": _vm.lang.valuation_form_required_error,
      "data-balloon-pos": "right"
    }
  }, [_c('label', {
    staticClass: "silver",
    attrs: {
      "for": "client_street_number"
    }
  }, [_vm._v(_vm._s(_vm.lang.valuation_form_street_number))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_street_number),
      expression: "client_street_number"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "client_street_number",
      "id": "client_street_number"
    },
    domProps: {
      "value": (_vm.client_street_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client_street_number = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "single_page__form_item",
    class: {
      'invalid': _vm.errors.has('client_postal_code')
    },
    attrs: {
      "data-balloon": _vm.lang.valuation_form_required_error,
      "data-balloon-pos": "right"
    }
  }, [_c('label', {
    staticClass: "silver",
    attrs: {
      "for": "client_postal_code"
    }
  }, [_vm._v(_vm._s(_vm.lang.valuation_form_postal_code))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_postal_code),
      expression: "client_postal_code"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "client_postal_code",
      "id": "client_postal_code"
    },
    domProps: {
      "value": (_vm.client_postal_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client_postal_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "single_page__form_item",
    class: {
      'invalid': _vm.errors.has('client_document_number')
    },
    attrs: {
      "data-balloon": _vm.lang.valuation_form_required_error,
      "data-balloon-pos": "right"
    }
  }, [_c('label', {
    staticClass: "silver",
    attrs: {
      "for": "client_document_number"
    }
  }, [_vm._v(_vm._s(_vm.lang.valuation_form_passport_number))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_document_number),
      expression: "client_document_number"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "client_document_number",
      "id": "client_document_number"
    },
    domProps: {
      "value": (_vm.client_document_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client_document_number = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "single_page__form_item",
    class: {
      'invalid': _vm.errors.has('client_document_issued')
    },
    attrs: {
      "data-balloon": _vm.lang.valuation_form_required_error,
      "data-balloon-pos": "right"
    }
  }, [_c('label', {
    staticClass: "silver",
    attrs: {
      "for": "client_document_issued"
    }
  }, [_vm._v(_vm._s(_vm.lang.valuation_form_gifted))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_document_issued),
      expression: "client_document_issued"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "client_document_issued",
      "id": "client_document_issued"
    },
    domProps: {
      "value": (_vm.client_document_issued)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client_document_issued = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "single_page__form_item",
    class: {
      'invalid': _vm.errors.has('client_phone')
    },
    attrs: {
      "data-balloon": _vm.lang.valuation_form_required_error,
      "data-balloon-pos": "right"
    }
  }, [_c('label', {
    staticClass: "silver",
    attrs: {
      "for": "client_phone"
    }
  }, [_vm._v(_vm._s(_vm.lang.valuation_form_phone))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_phone),
      expression: "client_phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "client_phone",
      "id": "client_phone"
    },
    domProps: {
      "value": (_vm.client_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "single_page__form_item",
    class: {
      'invalid': _vm.errors.has('client_email')
    },
    attrs: {
      "data-balloon": _vm.lang.valuation_form_email_error,
      "data-balloon-pos": "right"
    }
  }, [_c('label', {
    staticClass: "silver",
    attrs: {
      "for": "client_email"
    }
  }, [_vm._v(_vm._s(_vm.lang.valuation_form_email))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_email),
      expression: "client_email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('email|required'),
      expression: "'email|required'"
    }],
    class: {
      'invalid': _vm.errors.has('form_email')
    },
    attrs: {
      "type": "text",
      "name": "client_email",
      "id": "client_email"
    },
    domProps: {
      "value": (_vm.client_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "single_page__form_buttons"
  }, [_c('button', {
    staticClass: "single_page__button",
    attrs: {
      "id": "single_page__back"
    },
    on: {
      "click": _vm.to_first_screen
    }
  }, [_vm._v(_vm._s(_vm.lang.valuation_back))]), _vm._v(" "), _c('button', {
    staticClass: "single_page__button",
    attrs: {
      "id": "single_page__send"
    },
    on: {
      "click": _vm.generate_pdf
    }
  }, [_vm._v(_vm._s(_vm.lang.valuation_send))])])])])
},staticRenderFns: []}

/***/ }),

/***/ 212:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cov-vue-date"
  }, [_c('div', {
    staticClass: "datepickbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date.time),
      expression: "date.time"
    }],
    staticClass: "cov-datepicker",
    style: (_vm.option.inputStyle ? _vm.option.inputStyle : {}),
    attrs: {
      "type": "text",
      "title": "input date",
      "readonly": "readonly",
      "placeholder": _vm.option.placeholder,
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.date.time)
    },
    on: {
      "click": _vm.showCheck,
      "foucus": _vm.showCheck,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.date.time = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.showInfo.check) ? _c('div', {
    staticClass: "datepicker-overlay",
    style: ({
      'background': _vm.option.overlayOpacity ? 'rgba(0,0,0,' + _vm.option.overlayOpacity + ')' : 'rgba(0,0,0,0.5)'
    }),
    on: {
      "click": function($event) {
        _vm.dismiss($event)
      }
    }
  }, [_c('div', {
    staticClass: "cov-date-body",
    style: ({
      'background-color': _vm.option.color ? _vm.option.color.header : '#3f51b5'
    })
  }, [_c('div', {
    staticClass: "cov-date-monthly"
  }, [_c('div', {
    staticClass: "cov-date-previous",
    on: {
      "click": function($event) {
        _vm.nextMonth('pre')
      }
    }
  }, [_vm._v("«")]), _vm._v(" "), _c('div', {
    staticClass: "cov-date-caption",
    style: ({
      'color': _vm.option.color ? _vm.option.color.headerText : '#fff'
    })
  }, [_c('span', {
    on: {
      "click": _vm.showYear
    }
  }, [_c('small', [_vm._v(_vm._s(_vm.checked.year))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.showMonth
    }
  }, [_vm._v(_vm._s(_vm.displayInfo.month))])]), _vm._v(" "), _c('div', {
    staticClass: "cov-date-next",
    on: {
      "click": function($event) {
        _vm.nextMonth('next')
      }
    }
  }, [_vm._v("»")])]), _vm._v(" "), (_vm.showInfo.day) ? _c('div', {
    staticClass: "cov-date-box"
  }, [_c('div', {
    staticClass: "cov-picker-box"
  }, [_c('div', {
    staticClass: "week"
  }, [_c('ul', _vm._l((_vm.library.week), function(weekie) {
    return _c('li', [_vm._v(_vm._s(weekie))])
  }))]), _vm._v(" "), _vm._l((_vm.dayList), function(day) {
    return _c('div', {
      staticClass: "day",
      class: {
        'checked': day.checked, 'unavailable': day.unavailable, 'passive-day': !(day.inMonth)
      },
      style: (day.checked ? (_vm.option.color && _vm.option.color.checkedDay ? {
        background: _vm.option.color.checkedDay
      } : {
        background: '#F50057'
      }) : {}),
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          _vm.checkDay(day)
        }
      }
    }, [_vm._v(_vm._s(day.value))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.showInfo.year) ? _c('div', {
    staticClass: "cov-date-box list-box"
  }, [_c('div', {
    staticClass: "cov-picker-box date-list",
    attrs: {
      "id": "yearList"
    }
  }, _vm._l((_vm.library.year), function(yearItem) {
    return _c('div', {
      staticClass: "date-item",
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          _vm.setYear(yearItem)
        }
      }
    }, [_vm._v(_vm._s(yearItem))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.showInfo.month) ? _c('div', {
    staticClass: "cov-date-box list-box"
  }, [_c('div', {
    staticClass: "cov-picker-box date-list"
  }, _vm._l((_vm.library.month), function(monthItem) {
    return _c('div', {
      staticClass: "date-item",
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          _vm.setMonth(monthItem)
        }
      }
    }, [_vm._v(_vm._s(monthItem))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.showInfo.hour) ? _c('div', {
    staticClass: "cov-date-box list-box"
  }, [_c('div', {
    staticClass: "cov-picker-box date-list"
  }, [_c('div', {
    staticClass: "watch-box"
  }, [_c('div', {
    staticClass: "hour-box"
  }, [_c('div', {
    staticClass: "mui-pciker-rule mui-pciker-rule-ft"
  }), _vm._v(" "), _c('ul', _vm._l((_vm.hours), function(hitem) {
    return _c('li', {
      staticClass: "hour-item",
      class: {
        'active': hitem.checked
      },
      on: {
        "click": function($event) {
          _vm.setTime('hour', hitem, _vm.hours)
        }
      }
    }, [_vm._v(_vm._s(hitem.value))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "min-box"
  }, [_c('div', {
    staticClass: "mui-pciker-rule mui-pciker-rule-ft"
  }), _vm._v(" "), _vm._l((_vm.mins), function(mitem) {
    return _c('div', {
      staticClass: "min-item",
      class: {
        'active': mitem.checked
      },
      on: {
        "click": function($event) {
          _vm.setTime('min', mitem, _vm.mins)
        }
      }
    }, [_vm._v(_vm._s(mitem.value))])
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-box"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.showInfo.check = false
      }
    }
  }, [_vm._v(_vm._s(_vm.option.buttons ? _vm.option.buttons.cancel : 'Cancel'))]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.picked
    }
  }, [_vm._v(_vm._s(_vm.option.buttons ? _vm.option.buttons.ok : 'Ok'))])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ })

},[171]);


// WEBPACK FOOTER //
// static/js/app.js